var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 244,
    viewBox: "0 0 249 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_2568_9359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216 133C216 187.676 323.5 243 130.5 243C-36.0002 243 44.9998 187.676 44.9998 133C44.9998 78.3238 83.2794 34 130.5 34C177.72 34 216 78.3238 216 133Z",
    fill: "url(#paint0_linear_2568_9359)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2568_9359",
    x: -8.69922,
    y: 0,
    width: 288.551,
    height: 277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17,
    result: "effect1_foregroundBlur_2568_9359"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2568_9359",
    x1: 25.3008,
    y1: 138.5,
    x2: 245.851,
    y2: 138.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#992FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D73FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertEllipse);
export default __webpack_public_path__ + "static/media/expert-ellipse.5d4ac5f904f4d4d6e0fa2a71d54e63ff.svg";
export { ForwardRef as ReactComponent };